import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPomme = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 82,
	height: 87,
	viewBox: "0 0 82 87",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M55.8574 15.7373C42.7532 22.474 41.1701 32.8158 42.0166 37.1446C35.3635 24.0978 43.3721 11.425 48.2081 6.71937L55.8574 15.7373Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3574 32.5051C47.7788 21.581 58.161 15.8191 66.2098 19.1389C76.3623 23.3267 78.9568 40.3776 72.0045 57.2232C65.0523 74.0688 51.186 84.3299 41.0335 80.1421C36.7355 78.3692 33.7924 74.291 32.3545 68.899C28.006 74.2362 22.6408 77.0735 17.5154 76.0305C8.07608 74.1095 3.02768 59.7577 6.23945 43.9747C9.45126 28.1916 19.707 16.9542 29.1464 18.875C34.5934 19.9835 38.5782 25.2313 40.3574 32.5051Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.2538 37.3459C69.7783 43.8853 67.5463 49.3995 64.2686 49.6624C60.9908 49.9253 57.9086 44.8372 57.3841 38.2978C56.8597 31.7585 59.0917 26.2442 62.3694 25.9813C65.6471 25.7185 68.7294 30.8066 69.2538 37.3459Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgPomme);
export default ForwardRef;
